import { styled } from 'styled-components';

import {
  colors,
  cssBreakpoints,
  fontSizesByType,
  maxWidth,
} from '#/theme/theme';

export const ArticleSearchHeroTitle = styled.div`
  font-size: ${fontSizesByType.h3[0]}px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    font-size: ${fontSizesByType.h3[2]}px;
  }
`;

export const ArticleSearchHeroContainer = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 0 auto;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    max-width: 622px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    max-width: ${maxWidth[2]}px;
  }
`;

export const ArticleSearchHeroWrapper = styled.div`
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 0 6px rgb(0 0 0 / 30%);
  background: ${colors.white};
  color: ${colors.mediumContentGrey};

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    max-width: ${maxWidth[2]}px;
  }
`;
